import { AddLayerObject } from 'maplibre-gl';

// Define the full screen polygon that covers the entire map
// Covers the whole world
export const fullScreenPolygon = [
  [
    [-180, 90], // Top-left (maximum bounds of the world map)
    [180, 90], // Top-right
    [180, -90], // Bottom-right
    [-180, -90], // Bottom-left
    [-180, 90], // Close the polygon
  ],
];

export const aerialMapboxLayer: AddLayerObject = {
  id: 'aerial-map-box-layer',
  layout: {
    visibility: 'visible',
  },
  paint: {
    'line-color': '#00FF6B',
    'line-width': 2,
  },
  source: {
    data: {
      features: [],
      type: 'FeatureCollection',
    },
    type: 'geojson',
  },
  type: 'line',
};

export const aerialMapboxLayerSourceId = aerialMapboxLayer.id;

export const aerialMapboxBackgroundLayer: AddLayerObject = {
  id: 'aerial-map-box-background-layer',
  layout: {},
  paint: {
    'fill-color': 'rgba(0, 0, 0, 0.7)', // Semi-transparent black
    'fill-opacity': 0.7, // Adjust opacity as needed
  },
  source: {
    data: {
      features: [],
      type: 'FeatureCollection',
    },
    type: 'geojson',
  },
  type: 'fill',
};

export const aerialMapboxBackgroundLayerSourceId =
  aerialMapboxBackgroundLayer.id;
